import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { BookOpen } from "lucide-react";

const P = ({ children }) => <p className="text-sm text-muted-foreground leading-relaxed mb-3">{children}</p>;
const L = ({ items }) => (
  <ul className="list-disc pl-5 space-y-1 mb-3 text-sm text-muted-foreground">
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ul>
);
const H = ({ children }) => <h4 className="font-medium text-foreground mt-4 mb-1">{children}</h4>;

const SECTIONS = [
  {
    id: "om",
    title: "Om Murphy og personalpolitikk",
    body: (
      <>
        <H>Personalhåndbokas formål</H>
        <P>Personalhåndboka skal gi informasjon til medarbeidere i Murphy-konsernet om de forhold som er sentrale i ansettelsesforholdet. Sammen med arbeidsavtalen gir den en oversikt over rettigheter og plikter du som medarbeider eller partner plikter å kjenne til og etterleve mens du er ansatt.</P>
        <H>Kort om Murphy</H>
        <P>Murphy er et tverrfaglig rådgivningsmiljø som samler juridiske tjenester, regnskap og revisjon. Murphy AS er morselskap for Murphy Legal AS, Murphy Regnskap AS og Murphy Revisjon AS. Vår tilnærming bygger på fire verdier: trygghet, lønnsomhet, smarte løsninger og nære relasjoner.</P>
        <H>Prinsipper for personalpolitikk</H>
        <P>Hovedmålet er å bidra til selskapets verdiøkning gjennom å fremstå som en attraktiv arbeidsplass med høyt kompetente og engasjerte ansatte. Murphy skal ha et godt arbeidsmiljø preget av trivsel, tillit og åpenhet, en lønnspolitikk som rekrutterer og beholder ansatte, og sikre alle medarbeidere mot yrkesskader og psykososiale belastninger.</P>
        <H>Sosialt i Murphy</H>
        <P>Høy trivsel er et viktig grunnlag for å prestere. Murphy tilrettelegger for et godt sosialt miljø med aktiviteter gjennom året, som sommerfest og julebord, og markerer bursdager og store merkedager.</P>
      </>
    ),
  },
  {
    id: "arbeidsreglement",
    title: "Arbeidsreglement (§1–§15)",
    body: (
      <>
        <H>§ 1 Prøvetid</H>
        <P>Murphy praktiserer normalt 6 måneders prøvetid. I prøvetiden gjelder gjensidig oppsigelsesfrist på 2 uker, og det avholdes to prøvetidssamtaler. Prøvetiden kan forlenges tilsvarende fravær i perioden.</P>
        <H>§ 2 Arbeidstid</H>
        <P>Ordinær arbeidstid er kl. 08:00–16:00 mandag til fredag, med 30 minutters ubetalt pause per dag. Ukentlig arbeidstid er 37,5 timer. Julaften og nyttårsaften er fridager.</P>
        <H>§ 3 Fleksitid</H>
        <P>Kjernetid er kl. 09:00–15:00 hvor alle må være på jobb. Avregningsperiode er seks måneder (31.12 og 30.06). Inntil 50 plusstimer eller 10 minustimer kan overføres. Avspasering skal godkjennes av leder på forhånd.</P>
        <H>§ 4 Overtid</H>
        <P>All overtid skal være pålagt og følge arbeidsmiljøloven. Pålagt overtid godtgjøres med 40 % overtidstillegg i tillegg til ordinær timelønn.</P>
        <H>§ 5 Ledende og særlig uavhengige stillinger</H>
        <P>Arbeidstakere i ledende og særlig uavhengige stillinger er unntatt arbeidstidskapittelet i arbeidsmiljøloven (kap. 10), og omfattes ikke av reglene om overtid og fleksitid.</P>
        <H>§ 6 Ferie</H>
        <P>Ansatte har 5 ukers ferie, og juli er normalt feriemåned. Feriepenger utgjør 12 % av fjorårets arbeidsvederlag og utbetales på junilønn. Inntil 12 dager kan overføres til påfølgende år etter skriftlig avtale.</P>
        <H>§ 7 Lønn</H>
        <P>Lønn utbetales siste dag i måneden. Feriepenger utbetales med junilønnen. Selskapet foretar årlig lønnsvurdering med virkning fra 1. august. Kontroller lønnsslippen mot bankkonto og arbeidsavtale, og meld fra ved feil uten ugrunnet opphold.</P>
        <H>§ 8 Skattetrekk</H>
        <P>Skattetrekk beregnes fra skattekort hentet digitalt fra Altinn. Det trekkes ikke skatt av feriepenger i juni, og halv skatt i desember.</P>
        <H>§ 9 Taushetsplikt, varsling og informasjonsbehandling</H>
        <P>Arbeidstaker skal bevare taushet om alle forhold av forretningsmessig karakter vedrørende Murphy, kunder, leverandører og samarbeidspartnere. Taushetsplikten vedvarer også etter at ansettelsesforholdet er avsluttet.</P>
        <H>§ 10 Bruk av IT-utstyr</H>
        <P>Datautstyr og e-post er arbeidsverktøy i arbeidsgivers tjeneste. Privat bruk skal skje utenfor arbeidstiden. Arbeidsgiver kan kontrollere bruk i tråd med arbeidsmiljøloven og personopplysningsforskriften.</P>
        <H>§ 11 Rusmidler og pengespill</H>
        <P>Ingen skal være påvirket av rusmidler i arbeidstiden eller ha fravær grunnet rusmiddelbruk. Arbeidstiden skal ikke brukes til pengespill.</P>
        <H>§ 12 Lojalitet</H>
        <P>Arbeidstaker skal kjenne og lojalt følge lover, forskrifter og interne retningslinjer. Bistillinger eller oppdrag i konkurrerende virksomhet krever godkjenning fra arbeidsgiver.</P>
        <H>§ 13 Erstatningsplikt</H>
        <P>Den ansatte plikter å erstatte skade på utstyr eller eiendom forårsaket ved forsett eller grov uaktsomhet.</P>
        <H>§ 14 Avslutning av arbeidsforholdet</H>
        <P>Oppsigelse skal skje skriftlig. I prøvetiden gjelder 14 dagers gjensidig oppsigelsestid; etter prøvetid 3 kalendermåneder. Ved opphør leveres alt selskapets materiell tilbake, og alle har krav på sluttattest.</P>
        <H>§ 15 Generelt</H>
        <P>Er du i tvil om dine plikter, ta det opp med nærmeste overordnede. Brudd kan medføre suspensjon, oppsigelse, avskjed og erstatningsansvar.</P>
      </>
    ),
  },
  {
    id: "hms",
    title: "HMS og verneombud",
    body: (
      <>
        <P>Frank Bredal er HMS-ansvarlig for Murphy-konsernet og har ansvar for oppfølging og oppdatering av HMS-systemet.</P>
        <P>Som hovedregel skal det velges verneombud i alle virksomheter. Har virksomheten færre enn 10 ansatte, kan arbeidsgiver og arbeidstakere skriftlig avtale en annen ordning. Blir det 10 ansatte eller mer, må verneombud velges.</P>
      </>
    ),
  },
  {
    id: "sykefravar",
    title: "Sykefravær, egenmelding og sykmelding",
    body: (
      <>
        <H>Sykefravær</H>
        <P>Meld fra om sykefraværet til nærmeste leder snarest mulig, senest innen arbeidstidens slutt første sykefraværsdag. Meldingen gis på den mest praktiske måten.</P>
        <H>Egenmelding</H>
        <P>Egenmelding kan benyttes inntil 3 kalenderdager om gangen, totalt 4 dager i en rullerende 12-månedersperiode. Er du syk lenger enn 3 dager eller mer enn 4 ganger, trengs sykmelding fra lege. <strong className="text-foreground">Egenmelding registreres i Murphy Control</strong> (under fanen Fravær).</P>
        <H>Sykmelding</H>
        <P>Sykmelding fra lege leveres til leder snarest mulig. Ved langvarig sykdom betaler selskapet lønn i arbeidsgiverperioden (16 dager); deretter søkes NAV om refusjon.</P>
      </>
    ),
  },
  {
    id: "barn",
    title: "Syke barn og omsorgsdager",
    body: (
      <>
        <P>Ved syke barn, varsle leder snarest mulig innen utløpet av første fraværsdag. Du har rett til:</P>
        <L items={[
          "10 omsorgsdager per kalenderår med ett eller to barn under 12 år",
          "15 omsorgsdager per kalenderår med mer enn to barn under 12 år",
          "Flere dager når du er alene om omsorgen, eller har kronisk sykt/funksjonshemmet barn under 18 år",
        ]} />
        <H>Når kan du bruke omsorgsdager?</H>
        <L items={[
          "Når barnet er sykt, eller den som har daglig barnetilsyn er syk",
          "Når barnet må følges til utredning/innleggelse i helseinstitusjon",
          "Ved legebesøk og lignende oppfølging",
        ]} />
        <P>Ikke ved ordinære foreldremøter, planlagt fravær (skoleferier/planleggingsdager), rutinekontroller eller ordinære tannlegebesøk. Fraværsregistrering gjøres i HR-systemet.</P>
        <H>Syke- og omsorgspenger</H>
        <P>NAV betaler syke- og omsorgspenger etter folketrygdens regler, opptil 6 G ved din eller dine barns sykdom.</P>
      </>
    ),
  },
  {
    id: "permisjon",
    title: "Permisjon og velferdspermisjoner",
    body: (
      <>
        <H>Permisjon ved fødsel og adopsjon</H>
        <P>Du har rett til permisjon ved fødsel og adopsjon etter arbeidsmiljøloven § 12. Les mer på NAVs sider.</P>
        <H>Velferdspermisjoner</H>
        <L items={[
          "Lege/tannlege: innvilges med lønn 1 gang per år",
          "Eget bryllup/flyttedag: 1 dag uten lønn",
          "Begravelse/dødsfall: 1 dag med lønn (+ inntil 2 dager uten lønn ved behov)",
          "Følge barn til lege: med lønn ett legebesøk per år per barn",
          "Innkjøring barnehage/SFO/dagmamma: inntil 2 dager fri med lønn",
          "Følge barn første skoledag: 1 dag med lønn",
          "Hviletid for gravide: 5 timer per uke siste 10 uker i svangerskapet",
        ]} />
      </>
    ),
  },
  {
    id: "goder",
    title: "Reiser, goder og forskudd",
    body: (
      <>
        <H>Reiser og utgiftskompensasjon</H>
        <P>Alle reiser forhåndsgodkjennes av nærmeste leder og bør planlegges i god tid. Utlegg føres i HR-/regnskapssystemet. Reiseutgifter dekkes etter regning, km-godtgjørelse etter statens satser. Bilag eldre enn 3 måneder dekkes ikke, og bøter er den enkeltes ansvar.</P>
        <H>Bonus, rabatter og andre fordeler</H>
        <P>Ansatte har ikke lov til å motta ytelser fra tredjeparter (kunder, leverandører) – gaver, bonuspoeng, rabatter e.l. – for å minimere kostnader og rapporteringsbyrde.</P>
        <H>Telefon og databriller</H>
        <P>Ved nyansettelse inngås egen avtale om telefoni (EKOM). Leder vurderer abonnement. Ved dokumentert behov dekker Murphy synsprøve og glass til databrille i sin helhet, samt inntil kr 700 for innfatning.</P>
        <H>Forskudd</H>
        <P>Forskudd innvilges kun unntaksvis, i forhold til opptjent netto lønn, og trekkes på første påfølgende lønn. Det utbetales ikke forskudd på feriepenger.</P>
        <H>Pensjon og forsikring</H>
        <P>Murphy tilbyr kollektiv pensjonsordning gjennom Duvi. Yrkesskadeforsikring dekker yrkesskade og yrkessykdom etter lov om yrkesskadeforsikring.</P>
      </>
    ),
  },
  {
    id: "sosiale-medier",
    title: "Retningslinjer for sosiale medier",
    body: (
      <>
        <P>Murphy er positive til ansattes bruk av sosiale medier, med tillit til begrenset bruk i arbeidstiden. Husk at taushetsplikt og arbeidsreglement også gjelder i sosiale medier.</P>
        <L items={[
          "Du er personlig ansvarlig for alt innhold du publiserer",
          "Gjør det klart at du snakker for deg selv, ikke på vegne av selskapet",
          "Respekter personvern, konfidensialitet og opphavsrett",
          "Unngå etnisitet, fornærmelser og uanstendighet – vis omtanke",
          "Bruk ikke samme passord i sosiale medier og på arbeidsplassen",
          "Offisiell bruk på vegne av Murphy må godkjennes av leder",
        ]} />
      </>
    ),
  },
  {
    id: "utvikling",
    title: "Medarbeiderutvikling",
    body: (
      <>
        <P>Du er selv ansvarlig for din egen utvikling, mens leder skal støtte, tilrettelegge og utfordre. Medarbeidersamtale gjennomføres 1 gang per år med en oppfølgingssamtale ca. et halvt år etter.</P>
        <P>Samtalen består av to deler: (1) tilbakemelding og oppsummering av foregående år, og (2) utviklingsplan for kommende år. Alle skal ha en utviklingsplan med klare mål. Sett SMARTE mål: Spesifikke, Motiverende, Ambisjonsrike, Relevante, Tidsbestemte og Enkle. Medarbeider bør ikke sette mer enn 4–5 utviklingsmål per år.</P>
      </>
    ),
  },
  {
    id: "varsling",
    title: "Varsling av kritikkverdige forhold",
    body: (
      <>
        <P>Varsling er å gå videre med kritikkverdige forhold til noen som kan gjøre noe med det – brudd på lover, interne regler eller etiske normer. Ansatte oppfordres til å varsle, og har plikt til det ved kriminelle forhold eller der liv og helse er i fare. Varsling kan gjøres anonymt, og den som varsler skal ikke straffes.</P>
        <P>Ledelsen har ansvar for behandlingen og varsleren skal ha tilbakemelding innen en uke.</P>
        <H>Hvem skal varsles?</H>
        <L items={[
          "Alle saker kan varsles til nærmeste leder eller daglig leder",
          "Personalsaker og arbeidsmiljøsaker kan varsles til daglig leder",
          "Oppnås ikke reaksjon, kan styreleder informeres",
          "Fører intern varsling ikke frem, kan den ansatte gå til offentlige tilsyn",
        ]} />
      </>
    ),
  },
];

export default function Personalhandbok() {
  return (
    <div className="bg-card border border-border rounded-xl p-6" data-testid="personalhandbok">
      <div className="flex items-center gap-3 mb-1">
        <BookOpen className="w-5 h-5 text-foreground" />
        <h3 className="font-display text-lg">Personalhåndbok</h3>
      </div>
      <p className="text-sm text-muted-foreground mb-6">Murphy AS og konsernets selskaper · Versjon 1.0 / juli 2026. Gjelder Murphy Legal AS, Murphy Regnskap AS og Murphy Revisjon AS.</p>
      <Accordion type="single" collapsible className="w-full" defaultValue="sykefravar">
        {SECTIONS.map((s) => (
          <AccordionItem key={s.id} value={s.id} data-testid={`handbook-section-${s.id}`}>
            <AccordionTrigger className="text-left text-sm font-medium hover:no-underline">{s.title}</AccordionTrigger>
            <AccordionContent>{s.body}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
